import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroup } from "../types";
import { FaqGroupDB } from "./FaqGroups";

export const getFaqGroups = async (): Promise<FaqGroup[]> => {
  const collectionRef = collection(db, `faqGroups`);

  const q = query(collectionRef, orderBy("order", "asc"));

  const faqGroupsSnapshot = await getDocs(q);

  return faqGroupsSnapshot.docs.map((doc) => new FaqGroupDB(doc).toFaqGroup());
};
